import _ from 'lodash';

// omit 过滤掉值为 null、undefined 的属性
export const omit = (obj) => _.omitBy(obj, _.isNil);

// omitEmpty 过滤掉值为 null、undefined、空字符串、空数组、空对象 的属性
export const omitEmpty = (obj) => _.omitBy(obj, _.isEmpty);

const formatByteSize = (size) => {
    const units = [ 'B', 'KB', 'MB', 'GB', 'TB', 'PB' ];
    let index = 0;
    while (size >= 1024) {
        size /= 1024;
        index++;
    }
    return `${parseFloat(size.toFixed(2))} ${units[index]}`;
};

export const formatFileSize = (size) => {
    if (size === 0) {
        return '0 B';
    }
    return formatByteSize(size);
};
